import React, { useEffect, useState } from 'react';

import { useResetAppState, useSimulationStatus } from '../../hooks';

import { SimulationResultPage } from '../pages';

/**
 * Shows the simulation result page when the simulation finishes.
 * Only used inside ParticipantLayout — operators don't see results.
 */
export function SimulationResultHandler({ children }: { children: React.ReactElement }): React.ReactElement {
  const [showSimulationResultPage, setShowSimulationResultPage] = useState<boolean>(false);
  const simulationStatus = useSimulationStatus();
  const resetAppSettings = useResetAppState();

  const shouldShowSimulationResultPage = simulationStatus.state === 'finished';

  useEffect(() => {
    if (shouldShowSimulationResultPage !== showSimulationResultPage) {
      setShowSimulationResultPage(shouldShowSimulationResultPage);
      if (!shouldShowSimulationResultPage) {
        resetAppSettings();
      }
    }
  }, [shouldShowSimulationResultPage, showSimulationResultPage, setShowSimulationResultPage, resetAppSettings]);

  return showSimulationResultPage ? <SimulationResultPage /> : children;
}
